import { Route } from 'vue-router';
import { getFromSessionStorage, hasPayload } from '@/apps/order/helper';
import ordersCreateRouter, { CONTEXT } from '@/apps/order/routes/ordersCreate';

const ensureTariffChangeData = async (to: Route): Promise<void> => new Promise<void>(async (resolve, reject) => {
  if (to.meta?.mode !== 'tariff-change') {
    resolve();
    return;
  }

  const ctx = to.meta?.ctx as string || CONTEXT;

  const windowState = window as unknown as { CONTRACT_DATA?: Record<string, any> };
  let contractData = hasPayload(windowState.CONTRACT_DATA) ? windowState.CONTRACT_DATA : undefined;

  // If not in window, try IDB (for reload scenarios)
  if (!contractData) {
    const idbKey = `${ctx}.contractData`;
    const storedContractData = getFromSessionStorage<Record<string, any>>(idbKey);
    contractData = hasPayload(storedContractData) ? storedContractData : undefined;

    if (contractData) {
      windowState.CONTRACT_DATA = contractData;
    }
  }

  if (to.name === 'orders-tariff-change') {
    resolve();
    return;
  }

  // Without CONTRACT_DATA off the initial route, redirect there to initialize
  if (!contractData) {
    const initialRoute = ordersCreateRouter.getRoutes().find((route) => route.name === 'orders-tariff-change');

    if (initialRoute) {
      const error = new Error(`to:${initialRoute.name}`);
      // Preserve contractUuid and store intended route for redirect after initialization
      if (to.params.contractUuid) {
        (error as any).params = { contractUuid: to.params.contractUuid };
      }
      // Store the intended route name so TariffChangeView can redirect there after initialization
      if (to.name) {
        sessionStorage.setItem('tariffChangeIntendedRoute', to.name as string);
        sessionStorage.setItem('tariffChangeIntendedParams', JSON.stringify(to.params));
      }
      reject(error);
      return;
    }
  }

  resolve();
});

export default ensureTariffChangeData;
